<!-- the component is used for video sections in edit mode and for markup video everywhere -->
<template>
  <div class="video-transcription-block">
    <a href="javascript:void(0)"
      class="collapse-toggle-title"
      @click="toggleTranscription">
      <span class="collapse-toggle">
        <i :class="[transcriptHidden ? 'plus' : 'minus']"></i>
      </span>
      Video Transcript
    </a>
    <transition name="slide">
      <div v-show="!transcriptHidden"
        class="video-transcription">
        <div class="video-transcription__inner">
          <h2 class="section-title">
            Video Transcription
          </h2>
          <a v-if="pdfUrl"
            class="icon-attachment-2 pdf-download-link"
            :href="pdfUrl">
            Download PDF
          </a>
          <div
            class="transcription-content"
            v-html="transcript"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        transcriptHidden: true,
      }
    },

    props: {
      transcript: {
        type: String
      },
      pdfUrl: {
        type: String
      },
      sectionType: {
        type: String
      }
    },

    methods: {
      toggleTranscription() {
        this.transcriptHidden = !this.transcriptHidden

        SOPHIA.clickToggleForGA({
          el: $('.collapse-toggle-title'),
          eventAction: this.transcriptHidden ? 'collapse' : 'expand',
          moduleName: this.sectionType + ' Section',
          fieldType: 'drawer'
        })
      }
    }
  }
</script>
